/*
 * Frost — Footer accordion. A standalone copy of orizza-footer.js (see
 * sections/frost-footer.liquid's own top comment for why): each of the
 * four mobile rows (Service / Shop / The House / E-Gift Card) is a button
 * + collapsible body, using the same grid-template-rows 0fr → 1fr
 * technique (see section-frost-footer.css) for the open/close animation.
 *
 * This markup is shared with desktop (see .frost-footer__desktop in the
 * CSS, where the headings render as plain non-interactive labels and the
 * link lists are always visible) — the JS below only ever runs against
 * the `[data-frost-ftr-mobile]` tree, so it never touches the desktop
 * copy of the same links.
 */
(function () {
  function toggleRow(row, open) {
    var button = row.querySelector('[data-frost-ftr-toggle]');
    row.setAttribute('data-open', open ? 'true' : 'false');
    if (button) button.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function initAccordion(root) {
    var rows = root.querySelectorAll('[data-frost-ftr-row]');
    if (!rows.length) return;

    rows.forEach(function (row) {
      var button = row.querySelector('[data-frost-ftr-toggle]');
      if (!button) return;
      button.addEventListener('click', function () {
        var isOpen = row.getAttribute('data-open') === 'true';
        toggleRow(row, !isOpen);
      });
    });
  }

  function setup() {
    document.querySelectorAll('[data-frost-ftr-mobile]').forEach(initAccordion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
